import { StyleSheet } from 'react-native';
import FontFamily from '../../../constants/fonts';

export const auditHistoryHeaderStyles = StyleSheet.create({
  container: {
    backgroundColor: '#F5F9FF',
    borderRadius: 8,
    overflow: 'hidden',
  },

  header: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },

  title: {
    fontSize: 16,
    fontWeight: '700',
    color: '#2D2D2D',
    fontFamily: 'Inter',
    lineHeight: 22,
  },

  statusSection: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    gap: 12,
  },

  label: {
    fontSize: 14,
    fontWeight: '400',
    color: '#4B4B4B',
    fontFamily: 'Inter',
  },

  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
    gap: 6,
  },

  statusBadge: {
    backgroundColor: '#008553',
  },

  statusBadgeInProgress: {
    backgroundColor: '#316BB8',
  },

  statusBadgeDeclined: {
    backgroundColor: '#D40020',
  },

  statusBadgeOverdue: {
    backgroundColor: '#CC6E16',
  },

  badgeText: {
    fontSize: 12,
    fontWeight: '700',
    color: '#FFFFFF',
    fontFamily: FontFamily.regular,
    textTransform: 'capitalize',
  },

  badgeTextDeclined: {
    color: '#FFFFFF',
  },

  createdSection: {
    paddingHorizontal: 20,
    paddingVertical: 12,
  },

  targetDateSection: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    gap: 4,
  },

  iconCircleContainer: {
    width: 28,
    height: 28,
    borderRadius: 20,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D8E7FB',
    justifyContent: 'center',
    alignItems: 'center',
  },

  infoText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#2D2D2D',
    fontFamily: 'Inter',
    lineHeight: 20,
  },

  bold: {
    fontWeight: '700',
  },
});
